<template>
  <div>
    <v-btn flat @click="goToPostsList">Volver a {{ link_name }}</v-btn>
  </div>
</template>

<script>
export default {
  props: {
    route_name: {
      type: String,
      required: false 
    },
    link_name: {
      type: String,
      required: false
    }
  },
  methods: {
    goToPostsList() {
      this.$router.push({
        name: this.route_name
      });
    }
  }
}
</script>

<style>

</style>